import React from "react";
import { useNavigate } from "react-router-dom";
import { useApp } from "../context/AppContext";
import Card from "../components/ui/Card";
import Button from "../components/ui/Button";

export default function Success() {
  const navigate = useNavigate();
  const { pendingTx } = useApp();

  const ref = pendingTx?.ref || "#DWD-2026-7843";
  const date = pendingTx?.date || "14 mars";
  const time = pendingTx?.time || "09:41";

  return (
    <div className="bg-[#f0f2f7] min-h-[560px] px-[18px] py-7 text-center screen-enter">
      {/* Icône succès */}
      <div className="w-16 h-16 bg-brand-success rounded-[18px] flex items-center justify-center mx-auto mt-10 mb-4">
        <i className="fa fa-check text-white text-3xl" />
      </div>

      <h2 className="text-[22px] font-bold text-brand-dark mb-1.5">Transaction réussie !</h2>
      <p className="text-xs text-gray-400 mb-6 leading-relaxed">
        Votre paiement a été traité<br />avec succès.
      </p>

      <Card className="mb-[18px] !p-[13px]">
        <div className="flex justify-between mb-1.5">
          <span className="text-[11px] text-gray-400">Référence</span>
          <span className="text-[11px] font-bold text-brand-dark">{ref}</span>
        </div>
        <div className="flex justify-between">
          <span className="text-[11px] text-gray-400">Date &amp; heure</span>
          <span className="text-[11px] font-bold text-brand-dark">
            {date} 2026 · {time}
          </span>
        </div>
      </Card>

      <Button fullWidth onClick={() => navigate("/")} className="mb-2.5">
        <i className="fa fa-home" /> &nbsp;Retour à l'accueil
      </Button>
      <Button fullWidth variant="secondary" onClick={() => navigate("/support")}>
        <i className="fa fa-headset" /> &nbsp;Un problème ? Contacter le support
      </Button>
    </div>
  );
}
